import ReactDOM from "react-dom/client"
import "./index.scss"
import { createBrowserRouter, RouterProvider } from "react-router-dom"
import App from "./App"
import "bootstrap/dist/css/bootstrap.min.css"
import Certificates from "./Pages/Certificates/Certificates"
import Catalog from "./Pages/Catalog/Catalog"
import Flyers from "./Pages/Flyers/Flyers"

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/certificates",
    element: <Certificates />,
  },
  {
    path: "/catalog",
    element: <Catalog />,
  },
  {
    path: "/flyers",
    element: <Flyers />,
  },
], {
  basename: '/to-engineers',
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <RouterProvider router={router} />
)
